import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {withSidePanel} from 'components/SidePanel';
import {AddDetailsButton, AddDetailsIcon, StyledDiv} from './styles';
import messages from './messages';
import CheckFeedbackModal from '../Modal';

@withSidePanel
@inject('store')
@observer
class FeedbackButton extends Component {
  onClick = () => {
    this.props.pushSidePanel({
      title: this.props.intl.formatMessage(messages.addDetails),
      content: <CheckFeedbackModal stepId={this.props.stepId} />
    });
  };

  render() {
    const {
      stepId,
      stepIndex,
      store: {
        checklist: {checklist}
      },
      intl: {formatMessage},
      isMobile
    } = this.props;

    const dataCy = `add-feedback-${stepIndex}`;
    let hasFeedback = false;

    if (checklist[stepId]) {
      const {feedbackText, mediaUrl} = checklist[stepId];

      if (feedbackText || mediaUrl) {
        hasFeedback = true;
      }
    }

    return (
      <AddDetailsButton data-cy={dataCy} hasFeedback={hasFeedback} onClick={this.onClick}>
        <AddDetailsIcon hasFeedback={hasFeedback} isMobile={isMobile} />
        <StyledDiv hasFeedback={hasFeedback} isMobile={isMobile}>
          {hasFeedback ? formatMessage(messages.detailsAdded) : formatMessage(messages.addDetails)}
        </StyledDiv>
      </AddDetailsButton>
    );
  }
}

export default injectIntl(FeedbackButton);
